import { i18n } from "@/i18n";

export const APP_TITLE = "MOSTA CRM";

const t = (key: string): string => String(i18n.global.t(key));

/**
 * Входные данные для расчёта заголовка вкладки.
 */
export type PageTitleContext = {
    /** route.path текущего маршрута */
    path: string;
    /** route.query.page для /main: 'chat' | 'project' | 'client' (может быть пустым или мусорным) */
    mainPage: string;
    /** Имя открытого проекта/клиента или '' — если не загружено, закрыто правами или чужое */
    entityName: string;
    /** Название выбранной выборки в аналитике или '' */
    analyticsName: string;
};

/** Склеивает "левая часть | правая часть". */
function join(left: string, right: string): string {
    if (!left) {
        return right;
    }
    return `${left} | ${right}`;
}

/**
 * Единая таблица соответствия «маршрут -> заголовок вкладки».
 * Главная, страница проекта и страница клиента — это один маршрут /main,
 * различаемый query-параметром page.
 */
export function resolvePageTitle(ctx: PageTitleContext): string {
    if (ctx.path === "/analytics") {
        return join(t("page_title_analytics"), ctx.analyticsName || APP_TITLE);
    }
    if (ctx.path === "/calendar") {
        return join(t("page_title_calendar"), APP_TITLE);
    }
    if (ctx.path === "/settings") {
        return join(t("page_title_settings"), APP_TITLE);
    }
    if (ctx.path === "/main" || ctx.path === "/") {
        if (ctx.mainPage === "project") {
            return join(ctx.entityName || t("page_title_project"), APP_TITLE);
        }
        if (ctx.mainPage === "client") {
            return join(ctx.entityName || t("page_title_client"), APP_TITLE);
        }
        // page отсутствует или невалиден — MainPage.onMounted всё равно приведёт его к 'chat'.
        return join(t("page_title_main"), APP_TITLE);
    }

    return APP_TITLE;
}
